import { useEffect, useState } from 'react'

/**
 * 현재 사용자가 모바일 환경에서 보고 있는지 확인하는 hook
 ** 디바이스가 터치 기반인지 확인 (pointer: coarse) 체크
 ** touch event가 있는지 확인
 ** 화면 사이즈가 500 이하인지 확인
 * @returns boolean
 */
export function useIsMobile() {
  const [isMobile, setIsMobile] = useState<boolean>(true)

  useEffect(() => {
    const checkMobile = () => {
      // 디바이스가 터치 기반인지 확인 (coarse = 손가락 같은 불정밀 입력)
      const match = window.matchMedia('(pointer: coarse)').matches
      // touch event가 있는지(모바일인지) 확인
      // TODO: 개발자도구로 모바일 device 설정 후 다시 풀면 touch event는 그대로여서 모바일로 인식됨
      const touch = 'ontouchstart' in window || navigator.maxTouchPoints > 0
      // 화면 사이즈가 작은지 확인
      const smallScreen = window.innerWidth <= 500

      setIsMobile(match || touch || smallScreen)
    }

    checkMobile()

    window.addEventListener('resize', checkMobile)

    return () => {
      window.removeEventListener('resize', checkMobile)
    }
  }, [])

  return isMobile
}
